import { defaultTheme, Icons, Typography } from '@agro-club/agroclub-shared'
import { DealType } from 'modules/domain/deal/types'
import styled, { keyframes } from 'styled-components'
import { ARouterLink } from 'views/components/Analytics'
import { ItemCard } from 'views/styled/ItemCardStyles'

export const CardWrapper = styled(ItemCard)<{ isExport: boolean; isForWarehouse: boolean; dealType: DealType }>`
  width: auto;
  min-width: 298px;
  row-gap: 8px;
  background: ${({ isExport, isForWarehouse, dealType }) => {
    if (isExport) {
      return defaultTheme.color.accentYellow800
    } else if (isForWarehouse) {
      return defaultTheme.color.purple8a
    } else if (dealType === DealType.railway) {
      return defaultTheme.color.accentCyan8a
    }
    return ''
  }};
  border-color: ${({ isExport, isForWarehouse, dealType }) => {
    if (isExport) {
      return defaultTheme.color.accentYellow500
    } else if (isForWarehouse) {
      return defaultTheme.color.purple16a
    } else if (dealType === DealType.railway) {
      return defaultTheme.color.accentCyan16a
    }
    return ''
  }};
`

export const CompanyWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const StatusesWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
`

export const StatusIcons = styled.div`
  display: flex;
  column-gap: 4px;
`
export const Company = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: fit-content;
  ${Typography.accentLarge}
`
export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  align-items: flex-start;
`

export const SignedMargin = styled.div<{ isGreen: boolean }>`
  ${Typography.accentLarge}
  color:${({ isGreen }) => (isGreen ? defaultTheme.color.accentApprove600 : defaultTheme.color.accentDestruct600)};
`
export const MarginOnWay = styled.div`
  ${Typography.bodyMedium}
`
export const ActualMargin = styled.div`
  ${Typography.accentMedium}
`
export const FixedMargin = styled.span`
  ${Typography.accentLarge} //в шаред
  background: rgba(255, 153, 0, 0.16);
`
export const Product = styled.div`
  width: 250px;
`

export const IconTrack = styled(Icons.IconPickup)<{ $approve: boolean }>`
  max-width: 16px;
  height: auto;

  path {
    fill: ${({ $approve }) => ($approve ? `${defaultTheme.color.primary600}` : `${defaultTheme.color.secondary300}`)};
  }
`

export const IconUser = styled(Icons.IconAccount)<{ $approve: boolean }>`
  max-width: 16px;
  height: auto;

  path {
    fill: ${({ $approve }) => ($approve ? `${defaultTheme.color.primary600}` : `${defaultTheme.color.secondary300}`)};
  }
`
export const IconSample = styled(Icons.IconSampling)`
  max-width: 16px;
  height: auto;

  path {
    fill: ${defaultTheme.color.primary600};
  }
`

export const IconCheckMark = styled(Icons.IconCheckMark)`
  max-width: 16px;
  height: auto;

  path {
    fill: ${defaultTheme.color.primary600};
  }
`

export const IconPosition = styled(Icons.IconDuplicate)`
  max-width: 16px;
  height: auto;
`

export const IconInstructions = styled(Icons.IconOrders1)<{ $approve: boolean }>`
  max-width: 16px;
  height: auto;

  path {
    fill: ${({ $approve }) => ($approve ? `${defaultTheme.color.primary600}` : `${defaultTheme.color.secondary300}`)};
  }
`

export const IconSpecification = styled(Icons.IconOrders1)<{ $markSpecification: boolean }>`
  max-width: 16px;
  height: auto;

  path {
    fill: ${({ $markSpecification }) =>
      $markSpecification ? `${defaultTheme.color.primary600}` : `${defaultTheme.color.secondary300}`};
  }
`

export const IconDocuments = styled(Icons.IconGdprData)<{ $markDocumentsRequest: boolean }>`
  max-width: 16px;
  height: auto;

  path {
    fill: ${({ $markDocumentsRequest }) =>
      $markDocumentsRequest ? `${defaultTheme.color.primary600}` : `${defaultTheme.color.secondary300}`};
  }
`

export const IconContracts = styled(Icons.IconDescription)<{ $hasSaleContractRequest: boolean }>`
  max-width: 16px;
  height: auto;

  path {
    fill: ${({ $hasSaleContractRequest }) =>
      $hasSaleContractRequest ? `${defaultTheme.color.primary600}` : `${defaultTheme.color.secondary300}`};
  }
`

export const IconOneC = styled(Icons.IconOnec)<{ $approve: boolean }>`
  max-width: 16px;
  height: auto;

  path {
    fill: ${({ $approve }) => ($approve ? `${defaultTheme.color.primary600}` : `${defaultTheme.color.secondary300}`)};
  }
`

export const IconPlanner = styled(Icons.IconPlanner)<{ $isRed: boolean }>`
  max-width: 16px;
  height: auto;

  path {
    fill: ${({ $isRed }) =>
      $isRed ? `${defaultTheme.color.accentDestruct600}` : `${defaultTheme.color.secondary600}`};
  }
`

export const Link = styled(ARouterLink)`
  color: ${defaultTheme.color.textPrimary900};

  &:hover {
    text-decoration: none;
  }
`
const fadeAnimation = (direction: 'in' | 'out') => keyframes`
  from {
    opacity: ${direction === 'in' ? 0 : 1};
  }
  to {
    opacity: ${direction === 'in' ? 1 : 0};

  }
`

export const AnimatedBatchesBlock = styled.div<{ isVisible: boolean }>`
  animation: ${({ isVisible }) => fadeAnimation(isVisible ? 'in' : 'out')} 150ms forwards;
`
